export class ItemRevisionProject {
  public constructor(
    public id: string,
    public name: string
  ) {}
}
